import WatchListEntryTableRow from "./WatchListEntryTableRow";

export default WatchListEntryTableRow;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/watch-list-entries-table/watch-list-entry-table-row/index.js